<template>
	<div class="md-grey-page applicant-reg center-horizontal">
		<div class="page-banner"></div>
			<section class="container-white">

				<!-- Stage Registration -->
				<section v-if="stage == 'registration'">
					<h2 class="page__main-title">{{ titleCase(companyName) }}<br>Applicant Registration</h2>
					<div class="divider-title">One click registration with social media</div>
					<div class="social-buttons">
						<a id="facebook" href="#" @click.prevent="registerFB" class="mdc-button mdc-button--raised btn--spinner button button--facebook button-social">
						<span class="mdc-button__icon" alt="facebook"></span></a>
						<a id="linkedin" :href="linkedinUrl" class="mdc-button mdc-button--raised btn--spinner button button--linkedin button-social">
						<span class="mdc-button__icon" alt="linkedin"></span></a>
						<a id="google" href="" @click.prevent="registerGoogle" class="mdc-button mdc-button--raised btn--spinner button button--google button-social">
						<span class="mdc-button__icon" alt="google"></span></a>
					</div>
					<div class="divider-title"><span>OR</span></div>
					<div class="width-100 mdc-textfield mdc-textfield--upgraded mdc-textfield__no-margin-top">
						 <input id="fullName" v-validate="'required'" type="text" v-model="fullName" class="mdc-textfield__input" name="fullname">
						 <label for="fullName" class="mdc-textfield__label mdc-textfield__label--float-above">Name</label>
					</div>
					<div class="width-100 mdc-textfield mdc-textfield--upgraded mdc-textfield__no-margin-top">
						 <input id="email" type="text" v-model="email" class="mdc-textfield__input" name="email">
						 <label for="email" class="mdc-textfield__label mdc-textfield__label--float-above">Email</label>
					</div>
					<div class="width-100 mdc-textfield mdc-textfield--upgraded mdc-textfield__no-margin-top">
						 <input id="mobile" type="tel" v-model="mobile" class="mdc-textfield__input" name="mobile" inputmode="numeric" pattern="[0-9]*">
						 <label for="mobile" class="mdc-textfield__label mdc-textfield__label--float-above">Mobile Number</label>
					</div>
					<div class="mdc-layout-grid">
						 <a class="mdc-button mdc-button--raised mdc-button-submit btn--spinner btn--spinner__wide-btn width-100" @click="registerManual(true)" tabindex="0">Send Registration Link</a>
             <a class="mdc-button mdc-button--raised mdc-button-submit btn--spinner btn--spinner__wide-btn width-100" v-if="isAgent" @click.prevent="registerManual(false)" tabindex="1">Register Applicant Details</a>
					</div>
				</section>

				<!-- Stage Registration Success -->
				<section v-if="stage == 'registration-success' && email.length > 0">
					Thank you. Please check your {{email}} inbox for your link to our secure registration form.
				</section>
				<section v-if="stage == 'registration-success' && mobile.length > 0">
					Thank you. Please check your mobile ({{mobile}}) for your link to our secure registration form.
				</section>

				<!-- Stage Registration Failure -->
				<section v-if="errorMsg.length > 0">
					<p class="message--error">{{errorMsg}}</p>
				</section>
			</section>
			<div class="applicant-reg__ba-logo">
				<a href="https://bestagent.co.uk"><img class="" src="/static/img/logo_circle.png" alt=""></a>
			</div>
	</div>
</template>

<script>
import axios from 'axios';
import qs from 'querystring';
import { init as initFB } from '@/libs/providers/fb';
import { init as initGoogle } from '@/libs/providers/google';
import {isLoggedIn} from '@/libs/auth0.js';

export default {
	props: {
		linkedin: {
			type: Boolean,
			default: false
		}
	},
	data: function() {
		return {
			companyId: 0,
			companyName: '',
			fullName: '',
			email: '',
			mobile: '',
			stage: 'registration',
			errorMsg: '',
      isAgent: false
		}
	},
  created : async function () {
    if (await isLoggedIn()) {
      console.log('is agent');
        this.isAgent = true;
    }
  },
	mounted: function() {
		// check linkedIn
		if(this.linkedin) {
			this.showSpinner('linkedin');
			this.companyId = this.$route.query.state;
			this.registerLinkedin();
		} else {
			this.companyId = this.$route.params.companyId;
		}

		const that = this;
		axios.get(this.config.services.companies + '/companyName/' + this.companyId).then(function(response) {
			that.companyName = response.data;
		}).catch(function(error) {
			console.error('error getting company name:', error);
		});

		initFB();
		initGoogle();
	},
	computed: {
		linkedinUrl() {
			const data = qs.stringify({
					'response_type' : 'code',
					'redirect_uri' : `${process.env.BASE_URL}/register/linkedin/callback`,
					'client_id' : '78dyng07s6xrbc',
					'client_secret' : 'w104AJpWr4f99wQA',
					'state' : this.companyId
			});
			return `https://www.linkedin.com/oauth/v2/authorization?${data}`;
		}
	},
	methods: {
		registerFB() {
			const that = this;
			this.showSpinner('facebook');
			window.FB.login(function (response) {
				if (response.authResponse) {
					FB.api('/me', {fields: 'name,email'}, function (response) {
						that.fullName = response.name;
						that.email = response.email;
						that.register(response.name, response.email, null, 'facebook');
					});
				}
			}, {scope: 'email'});
		},
		registerGoogle() {
			const that = this;
			this.showSpinner('google');
			window.gapi.auth2.getAuthInstance().signIn().then(function(user) {
				const profile = user.getBasicProfile();

				that.fullName = profile.getName();
				that.email = profile.getEmail();

				that.register(profile.getName(), profile.getEmail(), null, 'google');
			});
		},
		registerLinkedin() {
			const that = this;
			const code = this.$route.query.code;
			const state = this.$route.query.state;

			axios.post(this.config.services.companies + '/linkedInProfile', {
				code: code,
				state: state
			}).then(function(response) {
				that.fullName = `${response.data.firstName} ${response.data.lastName}`;
				that.email = response.data.emailAddress;
				that.register(that.fullName, response.data.emailAddress, null, 'linkedin');
			}).catch(function(error) {
				console.error('error:', error);
			});
		},
		registerManual(isAgentSendLink) {
			this.register(this.fullName, this.email, this.mobile, 'manual', isAgentSendLink);
		},
		register(fullName, email, mobile, provider, isAgentSendLink) {
			this.errorMsg = '';
			const that = this;
			const params = {
				companyId: this.companyId,
				fullName: fullName,
				email: email,
				mobile: mobile,
				provider: provider
			};
			axios.post(`${this.config.services.applicants}/register`, params)
			.then(function(response) {
				if(response.data.success) {
          if (that.isAgent && isAgentSendLink) {
            window.location = `/`;
          }
          else {
            window.location = `/register/${that.companyId}/${response.data.applicantId}`;
          }
				} else {
					if(response.data.errorCode == 'email-exists') {
						that.errorMsg = 'Sorry, your email is already registered on this company.';
					}
					if(response.data.errorCode == 'mobile-exists') {
						that.errorMsg = 'Sorry, your mobile number is already registered on this company.';
					}
				}
			})
			.catch(function(error) {
				console.error('error:', error);
			});
		},
		showSpinner(id) {
			var element = document.getElementById(id);
			element.classList.add('btn-spin--visible');
		},
		hideSpinner(id) {
			var element = document.getElementById(id);
			element.classList.remove('btn-spin--visible');
		},
		titleCase: function(str) {
   		var splitStr = str.toLowerCase().split(' ');
			for (var i = 0; i < splitStr.length; i++) {
				splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
			}
			// Directly return the joined string
			return splitStr.join(' ');
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Applicant-Reg.vue